import React from 'react';
import {ProgressPortraitList} from "./ProgressPortraitList";
import {progressPortraitListReducer, initState} from "./progressPortraitListReducer";

type Props = {
    clientGuid: string;
};

export const ClientProfileProgressPortraitPage = ({clientGuid}: Props) => {
    const [{
        pagination,
        sortBy,
        filter,
        selected,
        pageSize
    }, dispatch] = React.useReducer(progressPortraitListReducer, initState(clientGuid));

    return (
        <ProgressPortraitList
            dispatch={dispatch}
            pagination={pagination}
            filterValue={filter}
            selected={selected}
            sortBy={sortBy}
            pageSize={pageSize}
        />
    );
};
